import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {ContactIcon} from 'shells/icon/svg/contact-icon';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

import type {GetForm_form_createRules_contact as CreateRulesContactFragment} from 'nutshell-graphql-types';

import {CreateRulesActionText} from './create-rules-action-text';
import {isCreateRuleEmpty} from './helpers';

type Props = {
    createRules: CreateRulesContactFragment | null | undefined;
    onClick: () => void;
};

export function CreateRulesCardContact(props: Props) {
    return (
        // @ts-expect-error
        <TwoLineButtonCard borderColor={colors.person} onClick={props.onClick}>
            <TwoLine
                icon={ContactIcon}
                iconSize={24}
                iconColor={colors.person}
                topRow='Create a person'
                bottomRow={getSubtitle(props.createRules)}
                isLargeWithSmallBottomRow={true}
                shouldCenterSingleLine={true}
            />
            <CreateRulesActionText createRules={props.createRules} />
        </TwoLineButtonCard>
    );
}

function getSubtitle(createRules?: CreateRulesContactFragment | null): string | null | undefined {
    if (!createRules || isCreateRuleEmpty(createRules)) {
        return null;
    }

    const parts = [];
    if (createRules.tags.length) {
        const tagNames = createRules.tags
            .map((tag) => {
                return tag.name;
            })
            .join(', ');

        parts.push(`Tags: ${tagNames}`);
    }

    if (createRules.audiences.length) {
        const audienceNames = createRules.audiences
            .map((audience) => {
                return audience.name;
            })
            .join(', ');

        parts.push(`Audiences: ${audienceNames}`);
    }

    return parts.join(', ');
}
